import { render, staticRenderFns } from "./AdditionalsForm.vue?vue&type=template&id=5434114a&"
import script from "./AdditionalsForm.vue?vue&type=script&lang=js&"
export * from "./AdditionalsForm.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalsForm.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports